import { ReactElement, ReactNode } from 'react'
import { Box, SxProps, Theme } from '@mui/material'

interface Props {
  children: ReactNode
  sx?: SxProps<Theme>
}

const EmptyState = ({ children, sx }: Props): ReactElement => {
  return (
    <Box
      sx={[
        {
          py: 1.25,
          px: 0.5,
          fontSize: 12,
          color: 'rgba(0,0,0,0.38)',
          fontStyle: 'italic',
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Box>
  )
}

export default EmptyState
